var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChevronUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.24076 15.6508C3.88134 15.2315 3.9299 14.6002 4.34923 14.2407L11.3492 8.24074C11.7237 7.91975 12.2763 7.91975 12.6508 8.24074L19.6508 14.2407C20.0701 14.6002 20.1187 15.2315 19.7593 15.6508C19.3999 16.0701 18.7686 16.1187 18.3492 15.7593L12 10.3171L5.65081 15.7593C5.23148 16.1187 4.60018 16.0701 4.24076 15.6508Z",
    fill: "#040405"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronUp);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjI0MDc2IDE1LjY1MDhDMy44ODEzNCAxNS4yMzE1IDMuOTI5OSAxNC42MDAyIDQuMzQ5MjMgMTQuMjQwN0wxMS4zNDkyIDguMjQwNzRDMTEuNzIzNyA3LjkxOTc1IDEyLjI3NjMgNy45MTk3NSAxMi42NTA4IDguMjQwNzRMMTkuNjUwOCAxNC4yNDA3QzIwLjA3MDEgMTQuNjAwMiAyMC4xMTg3IDE1LjIzMTUgMTkuNzU5MyAxNS42NTA4QzE5LjM5OTkgMTYuMDcwMSAxOC43Njg2IDE2LjExODcgMTguMzQ5MiAxNS43NTkzTDEyIDEwLjMxNzFMNS42NTA4MSAxNS43NTkzQzUuMjMxNDggMTYuMTE4NyA0LjYwMDE4IDE2LjA3MDEgNC4yNDA3NiAxNS42NTA4WiIgZmlsbD0iIzA0MDQwNSIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };